import * as GuestbookCommentActionTypes from '../../../constants/comments/GuestbookCommentActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'writer',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GuestbookCommentActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'writer',
            };

        case GuestbookCommentActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
